import { InjectionToken, Provider } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from './notification.service';

export interface InternalNotification {
	id: string;
	message: string;
	type: 'info' | 'success' | 'warning' | 'error';
	timestamp: Date;
	showToast: boolean;
}

export interface NotificationStorage {
	notifications: InternalNotification[];
	lastUpdated: number;
	userId: string;
	storageKey: string;
}

export const NOTIFICATION_SERVICE = new InjectionToken<NotificationService>('NOTIFICATION_SERVICE');

export function provideNotificationService(): Provider[] {
	return [
		{
			provide: NOTIFICATION_SERVICE,
			useClass: NotificationService,
		},
		MatSnackBar,
	];
}
